// src/super_admin/SuperAdminDashboard.js
import React from "react";
import { Routes, Route, Link } from "react-router-dom";

// Import dei sotto-componenti
import CompaniesList from "./CompaniesList";
import CompanyDetails from "./CompanyDetails";
import AddUserForm from "./AddUserForm";

/**
 * Questo componente:
 * - Mostra il layout di base (sidebar + contenuto)
 * - Definisce le rotte interne sotto /super_admin/*
 *   (esempio: /super_admin/companies, /super_admin/companies/:companyId, ecc.)
 */
function SuperAdminDashboard() {
  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      {/* Sidebar / Menu di navigazione */}
      <aside
        style={{
          width: "200px",
          background: "#f1f1f1",
          padding: "10px",
          boxSizing: "border-box",
        }}
      >
        <h2>Super Admin</h2>
        <nav>
          <ul style={{ listStyle: "none", padding: 0 }}>
            {/*
              Invece di "companies" (relativo), usiamo "/super_admin/companies" (assoluto)
              per evitare che clic multipli generino percorsi annidati come
              "/super_admin/companies/companies/...".
            */}
            <li>
              <Link to="/super_admin/companies">Gestione Compagnie</Link>
            </li>
            {/* Puoi aggiungere altri link se vuoi altre sezioni */}
          </ul>
        </nav>
      </aside>

      {/* Contenuto principale */}
      <main style={{ flex: 1, padding: "20px" }}>
        <Routes>
          {/* Rotta di elenco compagnie: /super_admin/companies */}
          <Route path="companies" element={<CompaniesList />} />

          {/* Rotta di dettaglio compagnia: /super_admin/companies/:companyId */}
          <Route path="companies/:companyId" element={<CompanyDetails />} />

          {/* Rotta per aggiungere un utente: /super_admin/companies/:companyId/add_user */}
          <Route path="companies/:companyId/add_user" element={<AddUserForm />} />

          {/*
            Rotta di default per qualunque path non corrispondente all'interno di /super_admin:
            Se l'utente va a /super_admin, o /super_admin/xyz, mostriamo un messaggio
            con un Link per tornare a /super_admin/companies.
          */}
          <Route
            path="*"
            element={
              <div>
                Seleziona una voce dal menu o vai a{" "}
                <Link to="/super_admin/companies">Companies</Link>
              </div>
            }
          />
        </Routes>
      </main>
    </div>
  );
}

export default SuperAdminDashboard;
